@if (loading) {
  <div class="loader-host">
    <app-loading [centered]="true" [size]="'2x'"></app-loading>
  </div>
}

<div class="add">
  <sui-button
    variant="primary"
    [leadingIcon]="['fas', 'user-plus']"
    (click)="addPrincipals()"
  >
    {{ "object-permissions.button.add-principals" | translate }}
  </sui-button>
</div>
@if (!loading) {
  <div class="advanced-permissions">
    <!-- Permissions Matrix -->
    <div class="permissions-matrix">
      <!-- Header Row -->
      <div class="row header">
        <div class="cell principal-cell"></div>
        <div class="cell all-cell">All</div>
        @for (permission of viewPermissions; track permission) {
          <div class="cell permission-cell">
            {{ permission.name }}
          </div>
        }
      </div>
      <!-- Data Rows -->
      @for (principal of principals; track principal) {
        <div class="row">
          <!-- Principal Info -->
          <div class="cell principal-cell">
            <div class="principal-info">
              <div class="action-col">
                <!-- Show Info icon if owner/admin -->
                @if (principal.is_owner || principal.is_business_admin) {
                  <div
                    class="info-icon"
                    [suiTooltip]="
                      'principal-info.tooltip.the-effective-permissions-are-inhertied-from-principals-role'
                        | translate
                    "
                  >
                    <fa-icon
                      [icon]="['fas', 'info']"
                      class="alert-icon"
                    ></fa-icon>
                  </div>
                }
                <!-- Hide remove button if owner/admin -->
                @if (!(principal.is_owner || principal.is_business_admin)) {
                  <sui-button
                    size="sm"
                    variant="danger"
                    [leadingIcon]="['fas', 'circle-minus']"
                    [iconOnly]="true"
                    [ariaLabel]="
                      'principal-info.tooltip.revoke-principals-permissions'
                        | translate
                    "
                    [suiTooltip]="
                      'principal-info.tooltip.revoke-principals-permissions'
                        | translate
                    "
                    (click)="removePrincipal(principal)"
                  ></sui-button>
                }
              </div>
              <!-- Avatar -->
              <img
                [src]="principal.image_url"
                alt="Principal avatar"
                appFallbackImage
              />
              <div class="principal-meta">
                <div class="name">{{ principal.name }}</div>
                <div class="email">{{ principal.email }}</div>
              </div>
            </div>
          </div>
          <!-- 'All' Checkbox Column -->
          <div class="cell all-cell">
            <sui-checkbox
              [disabled]="principal.is_owner || principal.is_business_admin"
              [checked]="
                principal.is_business_admin || hasAllPermissions(principal)
              "
              (checkedChange)="toggleAllPrincipalPermissions($event, principal)"
            ></sui-checkbox>
          </div>
          <!-- Permission Checkboxes -->
          @for (
            permission of viewPermissions;
            track trackByPerm($index, permission)
          ) {
            <div class="cell permission-cell">
              <sui-checkbox
                [disabled]="principal.is_owner || principal.is_business_admin"
                [checked]="
                  principal.is_business_admin ||
                  isPermissionChecked(permission, principal)
                "
                (checkedChange)="
                  handlePermissionClick($event, permission, principal)
                "
              ></sui-checkbox>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
